import type { CustomCompType } from '@neo/blocks/forms/types'
import { EnhancedTextArea } from 'v2/shared/components/enhanced-textarea'
import type { AiSkillsNodeData } from '../types'

type FormValues = AiSkillsNodeData['config']

// Shared component for instructions textarea across all skill configs
// TODO: Temporary fix ,later when language providers API is ready this component can be removed
export const SkillInstructionsTextArea = EnhancedTextArea as CustomCompType<FormValues>
